
































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { IssuePropertiesDTO } from "../../Generated/ParticaAPI";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";

@Component(
	{
		name: "IssueForm",
		components: {
			ButtonList,
			ParticaRowContainer,
			ParticaColumnContainer
		}
	})
export default class IssueForm extends ParticaBaseForm<IssuePropertiesDTO> {

	@Prop() private guid: string;
	@Prop() private thumburl: string;
	@Prop() private urls: string[];

	private nameconfig =
		{
			props: { name: "name", placeholder: "Enter name", label: "Issue Name", } as FormFieldProps,
			rules: { required: true, max: 200, min: 0, } as FormFieldRules
		} as IFormField;

	private issueDateconfig =
		{
			props: { name: "issueDate", placeholder: "Enter issueDate", label: "Issue Date", } as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;
	private issueDate: string = new Date().toISOString().substr(0, 10);
	private showpicker: boolean = false;


	private visibilityconfig =
		{
			props: {
				name: "visibility",
				placeholder: "Choose visibility",
				label: "Visible on website",
				required: true,
				disabled: true,
				values: [
					{ label: "Not on website", value: "notVisible" } as EnumDTO,
					{ label: "On website", value: "visible" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private secureconfig =
		{
			props: {
				name: "secure",
				placeholder: "Choose secure",
				label: "Issue Security",
				required: true,
				disabled: true,
				values: [
					{ label: "Not Secure", value: "notSecure" } as EnumDTO,
					{ label: "Secure", value: "secure" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private statusconfig =
		{
			props: {
				name: "status",
				placeholder: "Choose status",
				label: "Issue Status",
				required: true,
				disabled: true,
				values: [
					{ label: "Processing", value: "processing" } as EnumDTO,
					{ label: "Processed", value: "processed" } as EnumDTO,
					{ label: "Deleted", value: "deleted" } as EnumDTO,
					{ label: "Conversion Failed", value: "conversionfailed" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private urlFragmentconfig =
		{
			props: {
				name: "slug",
				placeholder: "Enter issue slug",
				label: "Issue Slug",
			} as FormFieldProps,
			rules: { required: true, max: 100, min: 0, } as FormFieldRules
		} as IFormField;


	@Watch("issueDate")
	private setissueDateModel(date: string) {
		this.model.issueDate = new Date(date);
	}
	@Watch("model")
	private setissueDate(date: Date) {
		this.issueDate = this.model.issueDate.toISOString().substr(0, 10);
	}
	private mounted(date: Date) {
		this.issueDate = this.model.issueDate.toISOString().substr(0, 10);
	}
	private getCoverImage() {
		return this.thumburl + this.guid + "/thumb/1.300.jpg";
	}
	private openIssue() {
		if (this.urls.length > 0) {
			window.open(this.urls[0], "issuewindow");
		}
	}

}
